module.exports = __webpack_public_path__ + "img/logo-200x200.ba64c181.png";